import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { LineChart } from "@mui/x-charts/LineChart";
import { ChartsReferenceLine } from "@mui/x-charts";

import { COOP_NOMINAL_VALUE, COOP_LOW_VALUE, COOP_MEDIUM_VALUE, NONCOOP_NOMINAL_VALUE, NONCOOP_LOW_VALUE, NONCOOP_MEDIUM_VALUE, formatXAxis } from "./hmsUtil";

import { useUserAuth } from "../contexts/authContext";

const HimsLatencyDialog = ({ selectedLatencyComponent, setSelectedLatencyComponent }) => {
    const [selectedLatencyData, setSelectedLatencyData] = useState([]);

    const { handleFailedFetch } = useUserAuth();

    useEffect(() => {
        handleFetchLatencyData();
    }, []);

    const handleFetchLatencyData = () => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ sensor_uuid: selectedLatencyComponent.sensor_uuid })
        };
        fetch("api/hms/latency", requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then((data) => setSelectedLatencyData(data))
            .catch((err) => handleFailedFetch(err));
    };
    return (
        <Dialog open={true} onClose={() => setSelectedLatencyComponent(null)} maxWidth="sm" fullWidth>
            <DialogTitle>{selectedLatencyComponent.name} Latency</DialogTitle>
            <DialogContent sx={{ pb: 0 }}>
                <Box sx={{ height: "300px" }}>
                    {Array.isArray(selectedLatencyData) && selectedLatencyData.length ? (
                        <LineChart
                            xAxis={[{ dataKey: "epoc_time", label: "Timestamp", valueFormatter: formatXAxis }]}
                            yAxis={[{ dataKey: "average", label: "Average (seconds)", min: 0 }]}
                            series={[{ dataKey: "average", color: "#8884d8" }]}
                            dataset={selectedLatencyData}
                            grid={{ vertical: true, horizontal: true }}
                            height={300}
                            data-testid="line-chart"
                        >
                            <ChartsReferenceLine
                                y={selectedLatencyComponent.sensor_type === "ADS_B" ? COOP_NOMINAL_VALUE : NONCOOP_NOMINAL_VALUE}
                                label="Nominal"
                                lineStyle={{ stroke: "green" }}
                            />
                            <ChartsReferenceLine
                                y={selectedLatencyComponent.sensor_type === "ADS_B" ? COOP_LOW_VALUE : NONCOOP_LOW_VALUE}
                                label="Low"
                                lineStyle={{ stroke: "orange" }}
                            />
                            <ChartsReferenceLine
                                y={selectedLatencyComponent.sensor_type === "ADS_B" ? COOP_MEDIUM_VALUE : NONCOOP_MEDIUM_VALUE}
                                label="Medium"
                                lineStyle={{ stroke: "red" }}
                            />
                        </LineChart>
                    ) : (
                        <></>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setSelectedLatencyComponent(null)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default HimsLatencyDialog;
